import { TokenProps } from '../layout/Control/Token';

type GetTokenAriaLabel =
  | ['OWN', string]
  | ['REMOVE_TOKEN_LABELLED', string | number]
  | ['REMOVE_TOKEN'];

export const getTokenAriaLabel = ({
  content,
  ...props
}: Pick<TokenProps, 'content' | 'aria-label'>): GetTokenAriaLabel => {
  const providedLabel = props['aria-label'];

  if (providedLabel) return ['OWN', providedLabel];

  if (typeof content === 'string' || typeof content === 'number')
    return ['REMOVE_TOKEN_LABELLED', content];

  return ['REMOVE_TOKEN'];
};
